import Controller from '../abstracts/Controller';
import 'scss-templates/t-cart.scss';

export default class CartController extends Controller {
  static get COMPONENTS() {
    return [
      'CartComponent',
      'StoreLocatorComponent',
      'PromocodeComponent',
      'GoogleRecommendationEngineComponent',
      'RecommendationEngineComponent',
    ];
  }

  scrollIfError() {
    if ($('#cart-authentication').data('checkoutloginError')) {
      window.scrollTo(0,document.querySelector('#cart-authentication').scrollHeight+500);
    }
  }

  init() {
    super.init();
    this.scrollIfError();

    /* LOGIN PAGE */
    const emailInput = document.querySelector('#j_username');
    const pwdInput = document.querySelector('#j_password');
    const submitButton = document.querySelector('#j_submit');
    if(emailInput){
      emailInput.addEventListener('input', () => {
        if (emailInput.value && emailInput.value != '' && pwdInput.value && pwdInput.value != '') {
          submitButton.classList.remove('disabled');
          submitButton.removeAttribute('disabled');
        } else {
          submitButton.classList.add('disabled');
          submitButton.setAttribute('disabled', 'disabled');
        }
      })
    }
    if(pwdInput){
      pwdInput.addEventListener('input', () => {
        if (emailInput.value && emailInput.value != '' && pwdInput.value && pwdInput.value != '') {
          submitButton.classList.remove('disabled');
          submitButton.removeAttribute('disabled');
        } else {
          submitButton.classList.add('disabled');
          submitButton.setAttribute('disabled', 'disabled');
        }
      })
    }
  }
}
